import { render, staticRenderFns } from "./FaqsCollapsibleContainer.vue?vue&type=template&id=69cb6ffd&scoped=true&"
import script from "./FaqsCollapsibleContainer.vue?vue&type=script&lang=ts&"
export * from "./FaqsCollapsibleContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FaqsCollapsibleContainer.vue?vue&type=style&index=0&id=69cb6ffd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cb6ffd",
  null
  
)

export default component.exports